import { LogicCashTodayBalanceServiceMock } from "./logicCashTodayBalance.types";

export const mockLogicCashTodayBalanceService = (): LogicCashTodayBalanceServiceMock => ({
  fetchLogicCashTodayBalances: jest.fn(),
  fetchLogicCashTodayBalanceById: jest.fn(),
});
